// extracted by mini-css-extract-plugin
export default {"img":"Breakwall_img__JBo44"};